var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-mobile"},[_c('span',{staticClass:"column"},_vm._l((_vm.segments),function(segment,index){return _c('span',[_c('b-icon',{attrs:{"size":"is-small","icon":_vm.iconsMap[segment]}}),_vm._v(" "),(index !== _vm.segments.length - 1)?_c('span',[_vm._v(" → ")]):_vm._e()],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56a8c428","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IconSegments.vue
// module id = null
// module chunks = 